// Hoe een lijst-tool inactieve (niet-deleted) rijen toont — input `inactiveMode` op de lijst-tools.
//   list   = achter de inactive-knop (generiek, de verdeling van de _ListService);
//   dimmed = gedimd in de hoofdlijst, alleen deleted achter de knop;
//   hidden = niet getoond, alleen deleted achter de knop.
// Inactief = listItem_isInactive (zie list-item-is-inactive.function.ts).
export const inactiveMode = {
    list: 'list',
    dimmed: 'dimmed',
    hidden: 'hidden',
} as const;

export type TInactiveMode = (typeof inactiveMode)[keyof typeof inactiveMode];
